import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { GridToolbar } from "@mui/x-data-grid";
import { useFormik } from "formik";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useActionData, useLoaderData, useSubmit } from "react-router-dom";
import * as Yup from "yup";
import Colors from "../../../../../assets/colors/Colors";
import {
  AppContext,
  PosBreadCrumb,
  PosDataGridTable,
  PosDatePicker,
  PosDropDown,
  PosFormButton,
  PosNoDataFound,
  PosProgress,
  PosTostMessage,
} from "../../../../../components/index";
import * as Constants from "../../../../../constants/Constants";
import {
  endOfTodaysDay,
  reportDateFormate,
  startOfTodaysDay,
  twofixs,
  commonDateFormate,
  useAnalytics,
} from "../../../../../helpers/utils/Utils";
import { PosErrorHook } from "../../../../../hooks";
import { WithRouter } from "../../../../../navigators/WithRouter";
import { downloadPDF } from "./CustomerCreditLedgerService";

const CustomerCreditLedger = (props) => {
  const { trackEvent } = useAnalytics();
  const { addToast } = PosTostMessage();
  const myContext = useContext(AppContext);
  const submit = useSubmit();
  const { error } = PosErrorHook();
  const actionResponse = useActionData();
  const loaderResponse = useLoaderData();
  const [tableData, setTableData] = useState([]);
  const [creditCustomerBalanceData, setCreditCustomerBalanceData] = useState(
    []
  );
  const [showTable, setShowTable] = useState(true);
  const [totalcount, setTotalCount] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [dateTimeValue, setdateTimeValue] = useState(new Date());
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDateFocus, setToDateFocus] = useState(false);
  const [fromDateView, setFromDateView] = useState(startOfTodaysDay());
  const [toDateView, setToDateView] = useState(endOfTodaysDay());
  const [totalDailySales, seltTotalDailySales] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState("");
  const [applyClicked, setApplyClicked] = useState(false);
  const pageRef = useRef(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [sortModel, setSortModel] = useState([
    {
      field: "id",
      sort: "asc",
    },
  ]);
  const paginationRef = useRef(paginationModel);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [olColumnVisibilityModel, setOlColumnVisibilityModel] = React.useState({
    id: false,
  });
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const actionColumn = isMobile ? { width: 150 } : { flex: 1 };
  const actionColumnFlexDouble = isMobile ? { width: 250 } : { flex: 1.5 };
  const columnNames = [
    { field: "sr_no", headerName: "Sr No.", sortable: false, width: 90 },
    { field: "id", headerName: "Id", sortable: false, width: 80  },
    {
      field: "date",
      headerName: "Date(UTC)",
      sortable: false,
      ...actionColumn,
    },
    {
      field: "description",
      headerName: "Description",
      sortable: false,
      ...actionColumnFlexDouble,
    },
    {
      field: "amount",
      headerName: "Amount($)",
      sortable: false,
      ...actionColumn,
    },
    {
      field: "type",
      headerName: "Type",
      sortable: false,
      ...actionColumn,
    },
    {
      field: "balance",
      headerName: "Balance($)",
      sortable: false,
      disableExport: true,
      resizable: false,
      filterable: false,
      width: 150,
    },
  ];

  const [loading, setLoading] = useState(true);
  const calendarRef = useRef(null);
  const toDateCalendarRef = useRef(null);
  const effectRun = useRef(true);
  const sortRef = useRef(sortModel);
  const [isExtraLarge] = useMediaQuery("(min-width: 1710px)");
  const [isLarge] = useMediaQuery("(max-width: 1435px)");
  const [isExtraSmall] = useMediaQuery("(max-width: 480px)");
  const [isMeduim] = useMediaQuery("(max-width: 1266px)");
  const formik = useFormik({
    initialValues: {
      selectedCustomers: "",
      selectedPaymentType: [],
      fromDate: "",
      toDate: "",
    },
    validateOnChange: true,
    validationSchema: Yup.object({
      selectedCustomers: Yup.string().required(
        Constants.CUSTOMER_CREDIT_SELECT_CUSTOMER
      ),
      fromDate: Yup.string().required(Constants.FORM_DATE_IS_REQUIRED),
      toDate: Yup.string().required(Constants.TO_DATE_IS_REQUIRED),
    }),
    onSubmit: async (values) => {},
  });

  useEffect(() => {
    if (effectRun.current === true) {
      if (
        undefined != loaderResponse &&
        null != loaderResponse &&
        {} != loaderResponse
      ) {
        if (
          undefined != loaderResponse?.error &&
          null != loaderResponse?.error &&
          loaderResponse?.error
        ) {
          let actionData = loaderResponse;
          error({ actionData });
          myContext.handleLoading(false);
        } else if (
          null !== loaderResponse.data[Constants.FLAGE] &&
          true === loaderResponse.data[Constants.FLAGE]
        ) {
          setCustomers(loaderResponse?.data?.data?.customer);
          myContext.handleLoading(false);
        }
      }
      return () => {
        effectRun.current = false;
      };
    }
    // getCustomerCreditData();
  }, []);

  // useEffect(() => {
  //   if (paginationRef.current !== paginationModel) {
  //     getCustomerCreditData();
  //     paginationRef.current = paginationModel;
  //   } else if (sortRef.current !== sortModel) {
  //     getCustomerCreditData();
  //     sortModel.current = sortModel;
  //   }
  // }, [paginationModel, sortModel]);

  useEffect(() => {
    if (pageRef.current) {
      getCustomerCreditData();
    }
  }, [paginationModel, sortModel]);

  useEffect(() => {
    if (
      undefined != actionResponse &&
      null != actionResponse &&
      {} != actionResponse
    ) {
      if (
        undefined != actionResponse?.error &&
        null != actionResponse?.error &&
        actionResponse?.error
      ) {
        let actionData = actionResponse;
        error({ actionData });
        setTableData([]);
        setTotalCount(0);
        setLoading(false);
        setButtonDisable(false);
        myContext.handleLoading(false);
      } else if (
        actionResponse.data[Constants.FLAGE] !== null &&
        actionResponse.data[Constants.FLAGE] === true
      ) {
        if (
          actionResponse.data?.message ===
          "Customer Credit Ledger Report successfully generated."
        ) {
          const url = Constants.REACT_APP_API_URL + actionResponse.data.data;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(Constants.DOWNLOAD, "CustomerCreditLedger.xlsx");
          document.body.appendChild(link);
          window.stop();
          link.click();
          window.URL.revokeObjectURL(url);
          link.remove();
          addToast({
            alertStatus: Constants.TOAST_TYPE_SUCESS,
            alertTitle: Constants.REPORT_MODULE,
            alertDescription: actionResponse.data?.message,
          });
          myContext.handleLoading(false);
        } else {
          setTableData(actionResponse.data.data.customerTransactionData);
          setCreditCustomerBalanceData(
            actionResponse.data.data.allCustomerLatestCreditBalance
          );
          let data = [
            "Opening Balance($)",
            twofixs(actionResponse.data.data.opening_balance),
          ];
          seltTotalDailySales(data);
          setTotalCount(actionResponse.data.data.totalItems);
          setLoading(false);
          setButtonDisable(false);
        }
      } else {
        let actionData = actionResponse?.data;
        error({ actionData });
        setTableData([]);
        setTotalCount(0);
        setLoading(false);
        setButtonDisable(false);
      }
    }
  }, [actionResponse]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        null !== calendarRef.current &&
        calendarRef.current &&
        fromDateFocus
      ) {
        calendarRef.current.hide();
        setFromDateFocus(false);
      }
      if (
        null !== toDateCalendarRef.current &&
        toDateCalendarRef.current &&
        toDateFocus
      ) {
        toDateCalendarRef.current.hide();
        setToDateFocus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [fromDateFocus, toDateFocus]);

  const handleExportReport = () => {
    formik.setTouched(
      {
        selectedCustomers: true,
        fromDate: true,
        toDate: true,
      },
      true
    );
    if(formik.values.selectedCustomers?.length === 0 ||
      formik.values.fromDate === "" ||
      formik.values.toDate === "" ||
      formik.errors.selectedCustomers ||
      formik.errors.fromDate ||
      formik.errors.toDate){
        return;
    }
    myContext.handleLoading(true);
    //   if (formik.values.selectedCustomers.length > 0) {
    // const allCustomersData =
    //   formik.values.selectedCustomers.length > 0
    //     ? JSON.stringify(formik.values.selectedCustomers)
    //     : JSON.stringify(customers);
    let data = {
      getreport: false,
      type: "xls",
      customer: JSON.stringify({
        id: selectedCustomers.id,
        name: selectedCustomers.name,
      }),
      transactionTypes: JSON.stringify(formik.values.selectedPaymentType),
      zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      query: JSON.stringify({
        limit: paginationModel.pageSize,
        page: paginationModel.page + 1,
        order:
          sortModel.length > 0 ? sortModel[0].field : sortRef.current[0].field,
        order_type:
          sortModel.length > 0 ? sortModel[0].sort : sortRef.current[0].sort,
      }),
    };
    if (formik.values.fromDate && formik.values.toDate) {
      data.dateFrom = reportDateFormat(formik.values.fromDate);
      data.dateTo = reportDateFormat(formik.values.toDate);
    }
    submit(data, {
      method: Constants.POST,
      path: Constants.CUSTOMER_CREDIT_LEDGER_ROUTE,
    });
  };
  const clearTableData = (message) => {
    // clear table data when remove date and location
    setTableData([]);
    setTotalCount(0);
    setLoading(false);
    setButtonDisable(false);
    myContext.handleLoading(false);
    addToast({
      alertStatus: Constants.TOAST_TYPE_WARNING,
      alertTitle: Constants.REPORT_MODULE,
      alertDescription: message,
    });
  };
  const getCustomerCreditData = () => {
    trackEvent("customers_credit_ledger_report_apply");
    formik.setTouched(
      {
        selectedCustomers: true,
        fromDate: true,
        toDate: true,
      },
      true
    );
    if(formik.values.selectedCustomers?.length === 0 ||
      formik.values.fromDate === "" ||
      formik.values.toDate === "" ||
      formik.errors.selectedCustomers ||
      formik.errors.fromDate ||
      formik.errors.toDate){
        return;
    }
    if (formik.values.selectedCustomers.length > 0) {
      if (null != formik.values.fromDate && "" != formik.values.fromDate) {
        if (null != formik.values.toDate && "" != formik.values.toDate) {
          setButtonDisable(true);
          setLoading(true);
          setShowTable(false);
          setApplyClicked(true);
          let data = {
            getreport: true,
            customer: JSON.stringify({
              id: selectedCustomers.id,
              name: selectedCustomers.name,
            }),
            zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            query: JSON.stringify({
              limit: paginationModel.pageSize,
              page: paginationModel.page + 1,
              order:
                sortModel.length > 0
                  ? sortModel[0].field
                  : sortRef.current[0].field,
              order_type:
                sortModel.length > 0
                  ? sortModel[0].sort
                  : sortRef.current[0].sort,
            }),
          };
          if (formik.values.selectedPaymentType) {
            data.transactionTypes = JSON.stringify(
              formik.values.selectedPaymentType
            );
          }
          if (formik.values.fromDate && formik.values.toDate) {
            data.dateFrom = reportDateFormat(formik.values.fromDate);
            data.dateTo = reportDateFormat(formik.values.toDate);
          }
          submit(data, {
            method: Constants.POST,
            path: Constants.CUSTOMER_CREDIT_LEDGER_ROUTE,
          });
        // } else {
        //   clearTableData(Constants.TO_DATE_IS_REQUIRED);
        }
      // } else {
      //   clearTableData(Constants.FORM_DATE_IS_REQUIRED);
      }
    // } else {
    //   clearTableData(Constants.CUSTOMER_IS_REQUIRED);
    }
  };

  const handleOptionSelect = (e) => {
    if (undefined !== e.value) {
      setSelectedCustomers(e.value);
      formik.setFieldValue("selectedCustomers", e.value.name);
    }
  };

  const handlePaymentOptionSelect = (e) => {
    formik.setFieldValue("selectedPaymentType", e.value);
  };

  const payment_type = [
    {
      label: "CREDIT",
      value: "CR",
    },
    {
      label: "DEBIT",
      value: "DR",
    },
  ];

  const handleResetAllData = () => {
    pageRef.current = false;
    setSortModel([
      {
        field: "id",
        sort: "desc",
      },
    ]);
    setPaginationModel({
      page: 0,
      pageSize: 25,
    });
    setTableData([]);
    setShowTable(true);
    setTotalCount(0);
    setSelectedCustomers([]);
    setFromDateView(startOfTodaysDay());
    setToDateView(endOfTodaysDay());
    formik.resetForm();
    setApplyClicked(false);
  };

  const hadleFromDateSelect = (e) => {
    if (
      null !== formik.values.toDate &&
      null != formik.values.toDate &&
      "" !== formik.values.toDate
    ) {
      if (moment(formik.values.toDate).isBefore(e.value)) {
        formik.setFieldValue("fromDate", e.value);
        formik.setFieldValue("toDate", e.value);
        setFromDateView(e.value);
        setToDateView(e.value);
      } else {
        formik.setFieldValue("fromDate", e.value);
        setFromDateView(e.value);
      }
    } else {
      formik.setFieldValue("fromDate", e.value);
      setFromDateView(e.value);
    }
  };
  function reportDateFormates(dateString) {
    if (!dateString) {
      return "";
    }
    const date = moment(dateString);
    const formattedDate = date.format("MM/DD/YYYY HH:mm:ss");
    return formattedDate;
  }

  // function reportDateFormat(dateString) {
  //   if (!dateString) {
  //     return "";
  //   }
  //   const date = moment(dateString);
  //   const formattedDate = date.format("MM/DD/YYYY HH:mm");
  //   return formattedDate;
  // }

  function reportDateFormat(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    
    const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  } 

  const modifiedData = tableData.map((data) => ({
    id: data.id,
    sr_no: data.sr_no,
    date: reportDateFormat(data.date),
    description: data.description,
    amount: data.amount,
    type: data.type,
    balance: data.balance,
  }));

  const handlePdfReport = () => {
    formik.setTouched(
      {
        selectedCustomers: true,
        fromDate: true,
        toDate: true,
      },
      true
    );
    if(formik.values.selectedCustomers?.length === 0 ||
      formik.values.fromDate === "" ||
      formik.values.toDate === "" ||
      formik.errors.selectedCustomers ||
      formik.errors.fromDate ||
      formik.errors.toDate){
        return;
    }
    myContext.handleLoading(true);
    let data = {
      customer: {
        id: selectedCustomers.id,
        name: selectedCustomers.name,
      },
      transactionTypes: formik.values.selectedPaymentType,
      zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      query: {
        limit: paginationModel.pageSize,
        page: paginationModel.page + 1,
        order:
          sortModel.length > 0 ? sortModel[0].field : sortRef.current[0].field,
        order_type:
          sortModel.length > 0 ? sortModel[0].sort : sortRef.current[0].sort,
      },
    };
    if (formik.values.fromDate && formik.values.toDate) {
      data.dateFrom = reportDateFormat(formik.values.fromDate);
      data.dateTo = reportDateFormat(formik.values.toDate);
      data.formatFromDate = reportDateFormate(formik.values.fromDate);
      data.formatToDate = reportDateFormate(formik.values.toDate);
    }
    try {
      downloadPDF(data)
        .then((response) => {
          if (
            undefined !== response.data.flag &&
            null !== response.data.flag &&
            response.data.flag == true
          ) {
            var url = Constants.REACT_APP_API_URL + response.data.data;
            // var url = `${Constants.REACT_APP_API_URL}${response.data.data}`;
            window.open(url, "_blank");
            setLoading(false);
            myContext.handleLoading(false);
          } else {
            setLoading(false);
            let actionData = response;
            error({ actionData });
            myContext.handleLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          let actionData = err;
          error({ actionData });
          myContext.handleLoading(false);
        });
    } catch (error) {
      setLoading(false);
      myContext.handleLoading(false);
    }
  };
  const renderReportLayout = () => {
    return (
      <>
        <Stack
          className="card justify-content-center"
          flexDirection={isLarge ? "column" : "row"}
          spacing={4}
          width={isLarge ? "100% !important" : "auto"}
          justifyContent={"space-between"}
        >
          <Stack
            width={"100% !important"}
            flexDirection={isExtraSmall ? "column" : "row"}
            justifyContent={"space-between"}
            spacing={4}
          >
            <Box width={"100% !important"}>
              <PosDropDown
                options={customers}
                value={selectedCustomers}
                onChange={handleOptionSelect}
                onBlur={(e) => {
                  formik.setFieldTouched("selectedCustomers");
                  formik.handleBlur(e);
                }}
                resetFilterOnHide={true}
                optionLabel="name"
                placeholder="Select Customer*"
                width={isExtraLarge ? "17rem" : "100%"}
                height={"2.5rem"}
                className="w-full md:w-20rem"
                maxSelectedLabels={2}
              />
              <Text color={Colors.errorColor}>
                {formik.touched.selectedCustomers &&
                formik.errors.selectedCustomers ? (
                  <span>{formik.errors.selectedCustomers}</span>
                ) : null}
              </Text>
            </Box>
            <Box width={"100% !important"}>
              <PosDropDown
                options={payment_type}
                value={formik.values.selectedPaymentType}
                onChange={handlePaymentOptionSelect}
                onBlur={(e) => {
                  formik.setFieldTouched("selectedPaymentType");
                  formik.handleBlur(e);
                }}
                resetFilterOnHide={true}
                multiSelect={true}
                optionLabel="label"
                placeholder="Payment Type"
                width={isExtraLarge ? "17rem" : "100%"}
                height={"2.5rem"}
                className="w-full md:w-20rem"
                maxSelectedLabels={2}
              />
            </Box>
          </Stack>
          <Stack
            width={"100% !important"}
            flexDirection={isExtraSmall ? "column" : "row"}
            justifyContent={"space-between"}
            spacing={4}
          >
            <Box width={"100% !important"}>
              <PosDatePicker
                id={"fromDate"}
                ref={calendarRef}
                value={formik.values.fromDate}
                label={"From Date*"}
                width={isExtraLarge ? "17rem" : "100%"}
                readOnlyInput={true}
                onFocus={() => {
                  if (
                    null !== toDateCalendarRef.current &&
                    toDateCalendarRef.current
                  ) {
                    toDateCalendarRef.current.hide();
                  }
                  setToDateFocus(false);
                  setTimeout(() => {
                    setFromDateFocus(true);
                  }, 1000);
                  formik.setFieldTouched("fromDate", true);
                }}
                handleSelectData={hadleFromDateSelect}
                yearRange={"2000:2030"}
                maxDate={dateTimeValue}
                viewDate={fromDateView}
                showButtonBar={true}
                showTime={true}
              />
              <Text color={Colors.errorColor}>
                {formik.touched.fromDate && formik.errors.fromDate ? (
                  <span>{formik.errors.fromDate}</span>
                ) : null}
              </Text>
            </Box>
            <Box width={"100% !important"}>
              <PosDatePicker
                id={"toDate"}
                ref={toDateCalendarRef}
                value={formik.values.toDate}
                label={"To Date*"}
                width={isExtraLarge ? "17rem" : "100%"}
                readOnlyInput={true}
                onFocus={() => {
                  if (null !== calendarRef.current && calendarRef.current) {
                    calendarRef.current.hide();
                  }
                  setFromDateFocus(false);
                  setTimeout(() => {
                    setToDateFocus(true);
                  }, 1000);
                  formik.setFieldTouched("toDate", true);
                }}
                handleSelectData={(e) => {
                  formik.setFieldValue("toDate", e.value);
                  setToDateView(e.value);
                }}
                yearRange={"2000:2030"}
                minDate={
                  null !== formik.values.fromDate &&
                  "" !== formik.values.fromDate
                    ? formik.values.fromDate
                    : dateTimeValue
                }
                maxDate={dateTimeValue}
                viewDate={toDateView}
                showButtonBar={true}
                showTime={true}
              />
              <Text color={Colors.errorColor}>
                {formik.touched.toDate && formik.errors.toDate ? (
                  <span>{formik.errors.toDate}</span>
                ) : null}
              </Text>
            </Box>
          </Stack>
        </Stack>
      </>
    );
  };
  return (
    <Box padding={{ base: 4, sm: 6, md: 10, lg: 14 }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        alignItems={{ base: "flex-start", md: "center" }}
        justify="space-between"
        pb={{ base: 6, md: 16 }}
        gap={2}
      >
        <PosBreadCrumb
          handleClick={(i) => {
            props.navigate(Constants.REPORT_PATH);
          }}
          breadCrumNames={["Reports", "Customer Credit Ledger"]}
          breadCrumTitle={"Customer Credit Ledger"}
        />
        <Spacer />
        <ButtonGroup gap="2" direction={"row"} alignSelf={"flex-end"}>
          <PosFormButton
            onClick={() => {
              props.navigate(Constants.REPORT_PATH);
            }}
            buttonText={"Cancel"}
            CancelButton={true}
          />
          {totalcount > 0 && (
            <Menu>
              <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                Export
              </MenuButton>
              <MenuList>
                <MenuItem onClick={handleExportReport}>Export Excel</MenuItem>
                <MenuItem onClick={handlePdfReport}>Export PDF</MenuItem>
              </MenuList>
            </Menu>
          )}
        </ButtonGroup>
      </Flex>
      <Box
        borderRadius="0.63rem"
        bg="white"
        boxShadow={"0px 0.25rem 0.5rem" + Colors.listShadow}
      >
        <Flex
          direction={isLarge ? "column" : "row"}
          justifyContent={{ base: "center", sm: "space-between" }}
        >
          <Stack
            gap={4}
            flex={1}
            flexShrink={"0"}
            direction={"column"}
            m={4}
            alignItems={"flex-start"}
          >
            {renderReportLayout()}
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={isLarge ? "flex-start" : "flex-end"}
            alignItems={"center"}
            pl={isLarge ? 4 : 0}
          >
            <PosFormButton
              isDisabled={applyClicked ? false : true}
              onClick={handleResetAllData}
              buttonText={"Reset"}
              ghostButton={true}
            />
            <PosFormButton
              buttonsubmit={"Apply"}
              SubmitButton={true}
              isDisabled={
                // formik.values.selectedCustomers?.length === 0 ||
                // formik.values.fromDate === "" ||
                // formik.values.toDate === "" ||
                // formik.errors.selectedCustomers ||
                // formik.errors.fromDate ||
                // formik.errors.toDate ||
                buttonDisable
              }
              onClick={getCustomerCreditData}
            />
          </Stack>
        </Flex>
        <Box p={4}>
          {showTable ? null : loading ? (
            <PosProgress />
          ) : totalcount > 0 ? (
            <Flex direction={"column"} gap={4}>
              <Table>
                <TableHead sx={{ backgroundColor: Colors.modifierTable }}>
                  <TableRow>
                    {totalDailySales.map((column, index) => {
                      return (
                        <TableCell
                          key={index}
                          sx={{
                            fontWeight: 500,
                            fontSize: "1rem",
                            lineHeight: "1.18rem",
                            letterSpacing: "-1.5%",
                            color: Colors.posTextInfo,
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          {column}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
              </Table>
              <PosDataGridTable
                columns={columnNames}
                rows={modifiedData}
                totalcount={totalcount}
                // noAction={true}
                columnVisibilityModel={olColumnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                  setOlColumnVisibilityModel(newModel)
                }
                paginationModel={paginationModel}
                onPaginationModelChange={(newPageModel) => {
                  pageRef.current = true;
                  setPaginationModel(newPageModel);
                }}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => {
                  pageRef.current = true;
                  sortRef.current = sortModel;
                  setSortModel(newSortModel);
                }}
                paginationMode="server"
                sortingMode="server"
                // onPaginationModelChange={setPaginationModel}
                // sortModel={sortModel}
                // onSortModelChange={setSortModel}
                slots={{
                  toolbar: GridToolbar,
                }}
                fileName={Constants.CUSTOMER_CREDIT_LEDGER_REPORT_CSV}
              />
            </Flex>
          ) : (
            <PosNoDataFound title={Constants.CUSTOMER_CREDIT_LEDGER_NO_DATA} />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default WithRouter(CustomerCreditLedger);
